import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { purple, transition } from './glowUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Table', 'heroTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      // 表头
      [`${componentCls}-thead > tr > th, ${componentCls}-thead > tr > td`]: {
        fontWeight: 600,
        letterSpacing: '0.02em',
        borderBottom: `2px solid ${purple[500]}20 !important`,
      },

      // 行 hover
      [`${componentCls}-tbody > tr`]: {
        transition,
        '&:hover > td': {
          background: `${purple[500]}08 !important`,
        },
      },

      // 选中行
      [`${componentCls}-tbody > tr${componentCls}-row-selected > td`]: {
        background: `${purple[500]}12 !important`,
      },

      // 排序列高亮
      [`${componentCls}-column-sort`]: {
        background: `${purple[500]}06 !important`,
      },
    },
  }
})
